import { render, staticRenderFns } from "./UsersInviteForm.vue?vue&type=template&id=56930e0b&scoped=true&"
import script from "./UsersInviteForm.vue?vue&type=script&lang=js&"
export * from "./UsersInviteForm.vue?vue&type=script&lang=js&"
import style0 from "./UsersInviteForm.vue?vue&type=style&index=0&id=56930e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56930e0b",
  null
  
)

export default component.exports